import React from 'react';
import {Droppable} from '@hello-pangea/dnd';
import Button from '../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactMenuPosition,
} from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';

export function FolderChip({
    folderKey,
    droppableId,
    selected,
    icon,
    title,
    count,
    onSelect,
    dataCy,
    actionItems,
    highlighted,
}: {
    folderKey: string;
    droppableId: string;
    selected: boolean;
    icon: string;
    title: string;
    count?: number;
    onSelect: () => void;
    dataCy?: string;
    actionItems?: {icon: string; label: string; onClick: () => void; color?: 'error'; dataCy?: string}[][];
    highlighted?: boolean;
}): JSX.Element {
    return (
        <Droppable droppableId={droppableId}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={`c-folderNav__chip${selected ? ' is-selected' : ''}${highlighted ? ' is-dropTarget' : ''}`}
                    onClick={onSelect}
                    data-cy={dataCy}
                    data-folder-droppable={folderKey}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') onSelect();
                    }}
                >
                    <Button leading={icon} size="sm" variant="ghost" square disablePointerEvents padded={false} />
                    <span className="c-folderNav__chip_title">{title}</span>
                    {typeof count === 'number' && <span className="c-folderNav__chip_count">{count}</span>}
                    {actionItems && actionItems.length > 0 && (
                        <span
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <DropdownMenuCompact items={actionItems} menuPosition={DropdownMenuCompactMenuPosition.LEFT} fixed="bottom">
                                <Button
                                    leading="ph:dots-three-vertical-bold"
                                    variant="ghost"
                                    square
                                    size="sm"
                                    type="button"
                                    dataCy="folder-menu"
                                />
                            </DropdownMenuCompact>
                        </span>
                    )}
                    <span style={{display: 'none'}}>{provided.placeholder}</span>
                </div>
            )}
        </Droppable>
    );
}
